import { forwardRef } from 'react';

import { Typography, TypographyProps, styled } from '@mui/material';

const ListItemComponent = forwardRef<HTMLElement, TypographyProps & { isChild?: boolean }>(
  ({ children, ...props }, ref) => (
    <Typography ref={ref} {...props}>
      {children}
    </Typography>
  ),
);
ListItemComponent.displayName = 'ListItemComponent';

export const ListItemName = styled(ListItemComponent)(({ theme }) => ({
  width: '15rem',
  fontSize: '0.75rem',
  fontWeight: 500,
  lineHeight: '110%',
  color: theme.palette.grey[900],
  margin: 0,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const Title = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.secondary.dark,
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '120%',
}));

export const Image = styled('img')(() => ({
  objectFit: 'cover',
  borderRadius: '0.3rem',
  height: '3rem',
  width: '3rem',
}));
